module.exports = __webpack_public_path__ + "img/icon_s-3.1.e1e34133.svg";